import React from 'react';
import { Link } from '@ipc/ipc-core';

export const FILE_NAME = 'settlement_records';
export const TITLE = 'SETTLEMENT RECORDS';

export const TABLE_COLUMNS = [
  {
    Header: 'Settlement Record Name',
    accessor: 'name',
    width: 150,
  },
  {
    Header: 'Date Type',
    accessor: 'dateType.label',
    width: 100,
  },
  {
    Header: 'Reporting Start Date',
    accessor: 'reportingStartDate',
    type: 'date',
    width: 100,
  },
  {
    Header: 'Reporting End Date',
    accessor: 'reportingEndDate',
    type: 'date',
    width: 100,
  },
  {
    Header: 'ALA Agreement Exception',
    accessor: 'alaAgreementException',
    Cell: ({ original: { alaAgreementException } }) => (!!alaAgreementException && <Link to="/configuration/agreements">View Agreements</Link>),
    type: 'boolean',
    width: 120,
  },
  {
    Header: 'Lowest ALA Level Achieved',
    accessor: 'lowestAlaLevel',
    type: 'number',
    width: 120,
  },
  {
    Header: 'Ala Fail Count',
    accessor: 'alaFailCount',
    type: 'number',
    width: 120,
  },
  {
    Header: 'Number of Receptacles',
    accessor: 'numberOfReceptacles',
    type: 'number',
    width: 110,
  },
  {
    Header: 'Group Status of receptacles',
    accessor: 'groupStatus',
    width: 110,
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 100,
  },
  {
    Header: 'External Data Used',
    accessor: 'externalDataUsed',
    width: 100,
  },
  {
    Header: 'Comment',
    accessor: 'comments',
    width: 140,
  },
  {
    Header: 'Last Comment Update',
    accessor: 'lastCommentUpdate',
    type: 'date',
    width: 140,
  },
  {
    Header: 'Comment creator',
    accessor: 'commentCreator',
    width: 140,
  },
  220,
];

export const COLUMNS = [
  {
    header: 'Settlement Record Name',
    key: 'name',
    width: 25,
  },
  {
    header: 'Date Type',
    key: 'dateType.label',
    width: 15,
  },
  {
    header: 'Reporting Start Date',
    key: 'reportingStartDate',
    width: 18,
  },
  {
    header: 'Reporting End Date',
    key: 'reportingEndDate',
    width: 18,
  },
  {
    header: 'ALA Agreement Exception',
    key: 'alaAgreementException',
    width: 20,
  },
  {
    header: 'Lowest ALA Level Achieved',
    key: 'lowestAlaLevel',
    width: 22,
  },
  {
    header: 'Number of Receptacles',
    key: 'numberOfReceptacles',
    width: 18,
  },
  {
    header: 'Group Status of receptacles',
    key: 'groupStatus',
    width: 22,
  },
  {
    header: 'Status',
    key: 'status',
    width: 12,
  },
  {
    header: 'External Data Used',
    key: 'externalDataUsed',
    width: 16,
  },
  {
    header: 'Comments',
    key: 'comments',
    width: 18,
  },
  {
    header: 'Last Comment Update',
    key: 'lastCommentUpdate',
    width: 18,
  },
  {
    header: 'Comment creator',
    key: 'commentCreator',
    width: 18,
  },
];
